<template>

	<div class="articleDetail">

		<div class="breadcrumb">内容管理 > 查看详情

			<el-button class="right_f" type="primary" @click="back">返回</el-button>
			<el-button v-if="articleForm.status == 2 " class="right_f" type="primary" @click="toTop">置顶</el-button>
			<el-button v-if="articleForm.status == 3 " class="right_f" type="primary" @click="noTop">取消置顶</el-button>
			<el-button class="right_f" type="primary" @click="noIssue">撤销发布</el-button>
			<el-button class="right_f" type="primary" @click="goComment">评论管理</el-button>

		</div>

		<div class="articleNum">
			<div class="readNum">阅读：{{articleForm.readNum}}</div>
			<div class="likeNum">顶：{{articleForm.likeNum}}</div>
			<div class="unlikeNum">踩：{{articleForm.unlikeNum}}</div>
		</div>

		<div class="detail">

			<el-form ref="articleForm" :model="articleForm" label-width="110px">

				<el-form-item label="封面图片">
					<img style="width: 325px; height: 125px;" :src="articleForm.url" alt="">
				</el-form-item>

				<el-form-item label="列表图片" v-if="articleForm.listImage">
					<img style="width: 325px; height: 125px;" :src="articleForm.listImage" alt="">
				</el-form-item>

				<el-form-item label="标题" class="articleTitle">
					<el-input v-model="articleForm.title" disabled></el-input>
				</el-form-item>

				<el-form-item label="摘要" class="articleAbstract">
					<el-input type="textarea" :autosize="{minRows: 3, maxRows: 5}" v-model="articleForm.abstract" disabled>
					</el-input>
				</el-form-item>
				<el-form-item label="初始阅读数" class="articleAuthor" prop="initReadCount">
					<el-input v-model="articleForm.initReadCount" disabled style="display:inline-block;"></el-input>
				</el-form-item>
				<el-form-item label="初始点赞数" class="articleAuthor" prop="initLikeCount">
					<el-input v-model="articleForm.initLikeCount" disabled style="display:inline-block;"></el-input>
				</el-form-item>
				<el-form-item label="作者" class="articleAuthor">
					<el-input v-model="articleForm.phone" disabled style="display:inline-block;"></el-input>{{articleForm.authorInfo}}
				</el-form-item>

				<el-form-item label="类别" class="articleType">
					<el-input v-model="articleForm.type" disabled></el-input>
				</el-form-item>

				<select-school :schObj="articleForm.schObj" :canUse="canUse"></select-school>

				<el-form-item>
					<el-checkbox class="radio" v-model="articleForm.ifNotice" disabled>首次发布，向所有用户发送更新通知</el-checkbox>
				</el-form-item>

				<el-form-item label="内容" class="articleContent">
					<el-input type="textarea" :autosize="{minRows: 20}" v-model="articleForm.content" disabled>
					</el-input>
				</el-form-item>
			</el-form>
		</div>

	</div>
</template>

<script>
	import selectSchool from "../../common/selectSch.vue"

	export default {
		data() {
			return {
				newsId: 1,
				canUse: false,
				articleForm: {
					url: '',
					listImage: "",
					status: null,
					title: '',
					abstract: '',
					author: '',
					phone: '',
					authorInfo: "",
					type: '',
					ifNotice: false,
					schObj: {
						applicableCampus: "0",
						shieldedSchools: [],
						openedSchools: []
					},
					content: '',
					initReadCount: '',  // 初始阅读数
					initLikeCount: '',  // 初始点赞数
					readNum: 0,
					likeNum: 0,
					unlikeNum: 0
				},
				url: ''
			}
		},
		mounted() {
			this.getArticle();
		},
		components: { selectSchool },
		methods: {
			getArticle() {
				let url = window.location.href;

				if (url.indexOf('?') !== -1) {
					this.newsId = this.$util.getUrlParam('newsId');
					this.getDetail(this.newsId);
				};

			},

			getDetail(newsId) {
				let url = this.$util.domain + '/adminapi/v4/operate/news/detail';

				this.$http({
					url,
					method: 'POST',
					emulateJSON: true,
					body: { newsId }
				}).then(responseData => {
					let response = responseData.data.data;
					let ifNotice = (response.publishNum === 0) ? false : true;

					this.articleForm = {
						ifNotice: ifNotice,
						url: response.coverImage,
						listImage: response.listImage,
						listUrl: response.coverImage,
						status: response.articleStatus,
						title: response.title,
						abstract: response.summary,
						schObj: {
							applicableCampus: response.applicableCampus ? response.applicableCampus + "" : "0",
							shieldedSchools: [],
							openedSchools: []
						},
						author: response.author,
						type: response.category,
						content: response.content,
						initReadCount: response.initReadCount || 0,
						initLikeCount: response.initLikeCount || 0,
						authorInfo: response.authorInfo,
						phone: response.phone,
						readNum: response.readCount,
						likeNum: response.likeCount,
						unlikeNum: response.unlikeCount
					}

					response.applicableCampus == 0 ? (this.articleForm.schObj.shieldedSchools = response.campusList) : (this.articleForm.schObj.openedSchools = response.campusList);
				}).catch(response => {
					this.$util.errorMsg('请求失败');
				})
			},

			back() {
				window.history.go(-1);
			},

			changeStatus(newStatus) {
				let url = this.$util.domain + '/adminapi/v1/operate/news/change_status';

				this.$http({
					url,
					method: 'POST',
					body: JSON.stringify({
						newsId: this.newsId,
						newStatus: newStatus
					})
				}).then(response => {

					if (response.data.error === 10000) {
						location.href = '/#/yunying/article/articleManage';
					}

				}).catch(response => {
					this.$util.errorMsg('请求失败');
				})

			},

			toTop() {
				let msg = "确定将该篇置顶吗？置顶功能会对用户端及管理后台同时生效，置顶后可以通过“取消置顶”按钮取消";
				this.popAction(msg, "置顶", 3);
			},

			noTop() {
				let msg = "确定将该篇取消置顶吗？取消置顶会使该篇根据发布或创建时间恢复至原位置，且对用户端及本管理后台同时生效";
				this.popAction(msg, "取消置顶", 2);
			},

			noIssue() {
				let msg = "确定要撤销发布吗？撤销发布后该篇会变成“已撤销”状态，且用户端将无法看到该篇内容";
				this.popAction(msg, "撤销发布", 9);
			},

			popAction(msg, title, status) {
				this.$confirm(msg, title, {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.changeStatus(status);
				}).catch(() => {
					//do nothing
				})
			},

			goComment() {
				location.href = '/#/yunying/comment/commentManage?newsId=' + this.newsId;
			}
		}
	}
</script>

<style>
	.articleNum {
		position: absolute;
		top: 100px;
		right: 100px;
	}

	.articleDetail .campSpan {
		display: block;
		text-align: center;
		float: left;
		height: 36px;
		padding: 0 30px 5px 15px;
		border: solid 1px #999;
		border-radius: 5px;
		margin: 10px;
		box-sizing: border-box;
		font-size: 12px;
		position: relative;
		cursor: pointer;
	}

	.articleDetail .campContain {
		width: 700px;
		height: 135px;
		border: solid 1px gray;
		box-sizing: border-box;
		overflow-y: scroll;
	}

	.gray {
		color: #999;
	}

	.campSpan i {
		width: 20px;
		height: 20px;
		line-height: 20px;
		color: #999;
		position: absolute;
		right: 5px;
		top: 5px;
	}
</style>


// WEBPACK FOOTER //
// articleDetail.vue?51f48650